"use client";

import dynamic from "next/dynamic";
import { useLocale } from "next-intl";
import { useAppConfiguration } from "appConfig";

// eslint-disable-next-line import/no-named-as-default
const ReCAPTCHA = dynamic(
  () => import("react-google-recaptcha").then((m) => m.default),
  { ssr: false, loading: () => <div className="h-[78px]" /> }
);

interface ReCaptchaProps {
  onChange: (token: string | null) => void;
}

export function ReCaptcha(props: ReCaptchaProps) {
  const { recaptchaSiteKey } = useAppConfiguration();
  const locale = useLocale();

  return (
    <div className="w-fit mx-auto my-5">
      {recaptchaSiteKey ? (
        <ReCAPTCHA
          sitekey={recaptchaSiteKey}
          hl={locale}
          onChange={props.onChange}
        />
      ) : null}
    </div>
  );
}
